import { NgModule } from "@angular/core";
import { DatePickerComponent } from "../date-picker/date-picker.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
  imports:[MatTooltipModule, CommonModule, ReactiveFormsModule]
})
export class SharedModule {}
  